import { MobizOrganizationRole, OrganizationMembership } from '../../core';
import { isNil } from '../../utils';
import { MobizSettingsValue } from './mobiz-settings-value.do';


/**
 * Base class for ModuleSettings objects.
 * Modules have behavior for enabling/disable module and configure ACL policies.
 *
 * TODO: Extend a generic OrganizationSettings object?
 */
export abstract class ModuleSettings extends MobizSettingsValue {

  /**
   * Flag to enable/disable module.
   */
  public ModuleEnabled: boolean;

  /**
   * Flag to enable role authorization for module usage.
   *
   * If empty then there everyone has access to module.
   */
  public AuthorizationRoles: MobizOrganizationRole[];

  /**
   * Checks if the membership is authorized.
   * @param membership The membership
   */
  public isMembershipRoleAuthorized(membership: OrganizationMembership) {
    if (!isNil(this.AuthorizationRoles)) {
      // TODO: 6132 - Move this logic to OrganizationMembership class
      // @see https://mobizehf.tpondemand.com/entity/6132-reports-web-assign-selectedmembership-correctly-to
      let find = this.AuthorizationRoles.find(role => role === membership.membershipRole);

      return !isNil(find);
    }
    return false;
  }

}
